import store from "@/services/store";

export default [
    {
        path: '/panoramic-photography',
        name: 'panoramic-photography',
        component: () => import(/* webpackChunkName: "panoramic-photography" */ '../components/PanoModuleNavigator.vue'),
        props: {parentRouteName: 'panoramic-photography'},
        meta: {
            title: 'PANORAMIC PHOTOGRAPHY',
            icon: 'mdi-map-marker-radius-outline'
        },
        children: [
            {
                path: 'map',
                name: 'panoramic-photography-map',
                component: () => import(/* webpackChunkName: "panoramic-photography" */ '../pages/Map.vue'),
                //props: route => ({showSecurePanos: route.query.secure === 'true' ? true : false}),
                meta: {
                    title: 'MAP',
                    icon: 'mdi-map-marker-radius-outline',
                    displayInNavigation: true,
                    pageTitle: 'Panoramic Photography (Map)',
                    gtm: 'panoramic-photography-map'
                }
            },
            {
                path: 'viewer/:globalId',
                name: 'panoramic-photography-viewer',
                component: () => import(/* webpackChunkName: "panoramic-photography" */ '../pages/Viewer'),
                props: true,
                meta: {
                    title: 'VIEWER',
                    icon: 'mdi-camera',
                    displayInNavigation: false,
                    pageTitle: 'Panoramic Photography (Viewer)',
                    gtm: 'panoramic-photography-viewer'
                },
                beforeEnter: (to, from, next) => {
                    store.dispatch('panoramicPhotography/selectItem', null)
                    store.dispatch('panoramicPhotography/getItemFromGlobalId', to.params.globalId)
                    next()
                }
            },
            {
                path: '/panoramic-photography',
                name: 'panoramic-photography-default',
                redirect: '/panoramic-photography/map',
                meta: {
                    title: 'redirect'
                }
            }
        ]
    }
]
